import { type EmployerGroup } from "@vidario/domain";
import { Popover } from "@vidario/ui";
import { type ReactElement } from "react";

/** The company's name, and „+N Schreibweisen" opening a list of every spelling with its count. */
export function CompanyName({ group }: { group: EmployerGroup }): ReactElement {
  const others = group.spellings.filter((s) => s.spelling !== group.name);
  return (
    <div className="flex min-w-0 flex-wrap items-baseline gap-x-2">
      <span className="truncate font-medium" title={group.name}>
        {group.name}
      </span>
      {others.length > 0 && (
        <Popover
          aria-label={`Schreibweisen von „${group.name}“`}
          trigger={
            <button
              type="button"
              className="cursor-pointer rounded-sm text-xs text-primary-700 underline underline-offset-2 hover:text-primary-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
            >
              +{others.length} {others.length === 1 ? "Schreibweise" : "Schreibweisen"}
            </button>
          }
        >
          <ul className="m-0 flex list-none flex-col gap-1 p-0">
            {group.spellings.map((s) => (
              <li key={s.spelling} className="flex justify-between gap-4">
                <span className="break-words">{s.spelling}</span>
                <span className="tabular-nums text-text-tertiary">{s.count}</span>
              </li>
            ))}
          </ul>
        </Popover>
      )}
    </div>
  );
}
